import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { isNullOrUndefined, ToastService } from '../core';
import { AdditionalInfoObject, AmmendExitActivityFilter, ConfigurationApi, ExitRequestActivity, LookupApi } from '../core/api.gen';
import { CommonService } from '../core/common.service';
import { DialogService } from '../core/dialog.service';
import { LoaderService } from '../core/loader.service';
import { LookupTypeKeys } from '../shared/lookup-type-keys';
import { nullSafe } from '../utils';

@Component({
  selector: 'eos-exit-task-amendment',
  templateUrl: './exit-task-amendment.component.html',
  styleUrls: ['./exit-task-amendment.component.css']
})
export class ExitTaskAmendmentComponent implements OnInit {

  activities: ExitRequestActivity[] = [];
  activity: any;
  isAscending: boolean = false;
  activityFilter = new UntypedFormGroup({
    exitType: new UntypedFormControl(null, [Validators.required]),
    exitSubType: new UntypedFormControl(null),
    officeLocation: new UntypedFormControl(null),
    nationalityType: new UntypedFormControl(null),
    rank: new UntypedFormControl(null),
    isActive: new UntypedFormControl(true)
  });
  exitTypes = [];
  exitSubType = [];
  officeLocation = [];
  nationalityType = [];
  rank = [];
  exitTypeId: number = 0;
  activityInfo: ExitRequestActivity;
  exitSubTypeValue = [];


  activityTypes = [
    {
      id: 100,
      displayText: 'Email',
      disabled: true
    },
    {
      id: 101,
      displayText: 'Profile update',
    },
    {
      id: 102,
      displayText: 'External',
      disabled: true
    },
    {
      id: 103,
      displayText: 'Request',
      disabled: true
    }
  ];
  constructor(
    private configurationService: ConfigurationApi,
    private common: CommonService,
    private lookupApi: LookupApi,
    private loader: LoaderService,
    private dialogService: DialogService,
    private router: Router,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.loadSupportingData().
      pipe(finalize(() => this.loader.clear()))
      .subscribe(p => {
        this.exitTypes = p.exitTypes.filter(i => ![10861].includes(i.id));
        this.exitSubType = p.exitSubTypes.filter(i => ![10916].includes(i.id));
        this.nationalityType = p.nationalityType;
        this.officeLocation = p.officeLocation;
        this.exitSubTypeValue = this.exitSubType;
        this.rank = p.rank;
      });
    this.valuechangeSubscription();
  }


  loadSupportingData() {
    this.loader.show();
    return forkJoin({
      exitTypes: this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.EXIT_TYPES]),
      exitSubTypes: this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.EXIT_SUBTYPES]),
      nationalityType: this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.ONBOARDING_TYPES]),
      officeLocation: this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.OFFICE_LOCATION]),
      rank: this.common.getAllGlobalRanks(),
    });
  }
  createActivity() {
    this.activityInfo = undefined;
    this.dialogService.showExitActivityEdit(this.activityInfo, this.exitTypes, this.exitSubTypeValue, this.nationalityType, this.officeLocation, this.rank, false)
      .result.then((result) => {
        if (result === 'success') {
          this.getActivities();
        }
      });
  }
  onSubmit() {
    this.getActivities();
  }
  getActivities() {
    if (this.activityFilter.valid) {
      this.loader.show();
      const filter = this.getFormData();
      this.configurationService.getExitActivities(filter)
        .pipe(
          finalize(() => this.loader.clear()))
        .subscribe(resp => {
          resp.map(act => {
            act['activityTypeString'] = this.activityTypes.find(a => a.id === act.activityType);
            return act;
          });
          this.activities = resp;
          this.activities = resp.filter(act => act.order !== 0).sort((a, b) => a.order < b.order ? -1 : 1).concat(resp.filter(act => act.order === 0));
          this.isAscending = true;
          this.activity = resp.filter(act => act.order !== 0).sort((a, b) => a.order < b.order ? -1 : 1).concat(resp.filter(act => act.order === 0));
          this.onChange(this.activityFilter.controls['isActive'].value);
        });
    }
  }
  editActivity(activity: ExitRequestActivity) {
    this.configurationService.getExitActivitiesById(activity.id).subscribe(
      res => {
        if (res) {
          this.activityInfo = res;
          this.dialogService.showExitActivityEdit(this.activityInfo, this.exitTypes, this.exitSubTypeValue, this.nationalityType, this.officeLocation, this.rank, true)
            .result.then((result) => {
              if (result === 'success') {
                this.getActivities();
              }
            });
        }
      });
  }
  clearForm() {
    this.activityFilter.reset();
    this.activityFilter.patchValue({ isCandidate: true });
    this.activity = [];
    this.activities = [];
  }


  getFormData() {
    const form = this.activityFilter.getRawValue();
    const filter = new AmmendExitActivityFilter({
      exitType: form.exitType,
      exitSubType: form.exitSubType,
      officeLocation: form.officeLocation,
      nationalityType: form.nationalityType
    });
    return filter;
  }

  valuechangeSubscription() {
    this.activityFilter.get('exitType')
      .valueChanges
      .subscribe(x => {
        if (x) {
          this.exitTypeId = x.id;
          this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.EXIT_SUBTYPES])
            .subscribe(resp => {
              //console.log(this.exitTypeId)
              this.exitSubType = resp.filter(i => ([this.exitTypeId].includes(i.parentFieldId)
                && ![10916].includes(i.id)));
            });
        }
        this.restControls();
      })
  }
  restControls() {
    this.activityFilter.get('exitSubType').reset();
    this.activityFilter.get('officeLocation').reset();
    this.activityFilter.get('nationalityType').reset();
  }

  onChange($event) {
    if ($event) {
      this.activities = this.activity.filter(x => x.isActive == true);
    }
    else {
      this.activities = this.activity.filter(x => x.isActive == true || x.isActive == false)
    }
  }

  sort() {
    if (!this.isAscending) {
      this.activities = this.activities.filter(act => act.order !== 0).sort((a, b) => a.order < b.order ? -1 : 1).concat(this.activities.filter(act => act.order === 0));
      this.isAscending = true;
    }
    else {
      this.activities = this.activities.filter(act => act.order !== 0).sort((a, b) => a.order > b.order ? -1 : 1).concat(this.activities.filter(act => act.order === 0));
      this.isAscending = false;
    }
  }
  updateOrder(act) {
    const exitActivity = this.getExitActivity(act);
    if (exitActivity.isActive && exitActivity.order <= 0) {
      this.toast.warning("Order should be greater than zero for an active activity")
    }
    else {
      this.configurationService.saveExitActivities(exitActivity)
        .pipe(finalize(() => {
          this.loader.clear();
        }))
        .subscribe(resp => {
          if (resp) {
            if (resp.statusCode == 400) {
              this.toast.warning('Activity with same order already exist');
            }
            else {
              this.toast.success('Order successfully updated');
            }
          }
        }, err => {
          this.toast.error('An error occurred. Please try again.');
        }
        );
    }
  }

  getExitActivity(rawValues) {
    const internalAct = new ExitRequestActivity(
      {
        activityType: rawValues.activityType,
        order: rawValues.order,
        header: rawValues.header,
        description: rawValues.description,
        exitTypeId: rawValues.exitTypeId,
        id: rawValues.id,
        isActive: rawValues.isActive,
        additionalInfoObj: !isNullOrUndefined(rawValues.additionalInfo) ? this.checkIfAdditionalInfoNull(JSON.parse(rawValues.additionalInfo)) : null,
      });
    return internalAct;
  }

  checkIfAdditionalInfoNull(rawValues) {
    const obj = new AdditionalInfoObject({
      exitSubTypes: rawValues.ExitSubTypes,
      officeLocation: rawValues.OfficeLocation,
      nationalityType: rawValues.NationalityType,
      isPartner: rawValues.IsPartner === 1 ? 1 : null,
      rank: rawValues.Rank,
    });
    Object.keys(obj).forEach(key => {
      if (obj[key] === null || obj[key] === undefined || nullSafe(() => obj[key].length === 0)) {
        delete obj[key];
      }
    });
    return !this.removeEmpty(obj) ? obj : null;
  }

  removeEmpty(additionalInfo) {
    return Object.values(additionalInfo).every(x => (x === null));
  }

}
